import { BlogCategories, BlogContent, BlogRef } from "@/data/blogData";
import { SERVER_BASE_URL } from "./base";

export const BlogService = {
  async blogTopList(): Promise<BlogRef[]>{
     const blogList =  await fetch(`${SERVER_BASE_URL}/blogs/top`);
     const blogs = await blogList.json();
     return blogs.data;
   },
    async blogCategoriesList(): Promise<BlogCategories[]>{
     const blogList =  await fetch(`${SERVER_BASE_URL}/blogs/category/list`);
     const blogs = await blogList.json();
     return blogs.data;
   },
    async blogFilteredList(category:string): Promise<BlogRef[]>{
     const blogList =  await fetch(`${SERVER_BASE_URL}/blogs/category/search/${category}`);
     const blogs = await blogList.json();
     return blogs.data;
   },
   async blogFilteredTagList(category:string): Promise<BlogContent>{
     const blogList =  await fetch(`${SERVER_BASE_URL}/blogs/category/searchtag/${category}`);
     const blogs = await blogList.json();
     return blogs.data;
   },
   async blogList(): Promise<BlogRef[]>{
     const blogList =  await fetch(`${SERVER_BASE_URL}/blogs`);
     const blogs = await blogList.json();
     return blogs.data;
   },
   async blogDetail(key:string): Promise<BlogContent>{
     const blogDetail = await fetch(`${SERVER_BASE_URL}/blogs/${key}`);
     const blog = await blogDetail.json()
     return blog.data;
   }
}